import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  dashboardGuestGuard,
  dashboardRoleGuard,
  clearDashboardSessionStorage,
  isStoredAccessTokenValid,
} from 'sham-components/services';

function isCustomerWithoutSeller(): boolean {
  if (!isStoredAccessTokenValid()) return false;

  try {
    const user = JSON.parse(globalThis.sessionStorage?.getItem('user') ?? 'null') as
      | { roles?: unknown }
      | null;
    const roles = user?.roles;
    return Array.isArray(roles) && roles.includes('Customer') && !roles.includes('Seller');
  } catch {
    return false;
  }
}

const guestGuard = dashboardGuestGuard('Seller', ['/app']);
const roleGuard = dashboardRoleGuard('Seller', ['/login']);

export const sellerGuestGuard: CanActivateFn = (route, state) => {
  if (isCustomerWithoutSeller()) return inject(Router).createUrlTree(['/signup']);
  const result = guestGuard(route, state);
  if (result === true) clearDashboardSessionStorage();
  return result;
};

export const sellerDashboardGuard: CanActivateFn = (route, state) => {
  if (!isStoredAccessTokenValid()) {
    clearDashboardSessionStorage();
    return inject(Router).createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }
  if (isCustomerWithoutSeller()) return inject(Router).createUrlTree(['/signup']);
  const result = roleGuard(route, state);
  if (result !== true) clearDashboardSessionStorage();
  return result;
};
